import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Endpoints from '../endpoints';
import { OrganisationDTO, SiteDTO, SensorDTO, UserDTO } from '../types/admin';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { OWN_ORGANISATIONS_AND_SITES } from '../../app.config';
import { OwnOrganisationsAndSites } from '../types/common';

@Injectable()
export class AdminService {
  constructor(private http: HttpClient,
              private commonService: CommonService) { }

  public getOrganisations(): Observable<OrganisationDTO[]> {
    return this.http.get<OrganisationDTO[]>(Endpoints.ORGANISATIONS);
  }

  public createOrganisation(data: OrganisationDTO): Observable<any> {
    return this.http.post(Endpoints.ORGANISATIONS, data);
  }

  public updateOrganisation(id:number, data: OrganisationDTO): Observable<any> {
    return this.http.patch(Endpoints.ORGANISATION(id), data);
  }

  public deleteOrganisation(id: number): Observable<any> {
    return this.http.delete(Endpoints.ORGANISATION(id));
  }


  public getSites(): Observable<SiteDTO[]> {
    return this.http.get<SiteDTO[]>(Endpoints.SITES);
  }

  public createSite(data: SiteDTO): Observable<any> {
    return this.http.post(Endpoints.SITES, data);
  }

  public updateSite(id:number, data: SiteDTO): Observable<any> {
    return this.http.patch(Endpoints.SITE(id), data);
  }

  public deleteSite(id: number): Observable<any> {
    return this.http.delete(Endpoints.SITE(id));
  }


  public getSensors(): Observable<SensorDTO[]> {
    return this.http.get<SensorDTO[]>(Endpoints.SENSORS);
  }

  public createSensor(data: SensorDTO): Observable<any> {
    return this.http.post(Endpoints.SENSORS, data);
  }

  public updateSensor(id:number, data: SensorDTO): Observable<any> {
    return this.http.patch(Endpoints.SENSOR(id), data);
  }

  public deleteSensor(id: number): Observable<any> {
    return this.http.delete(Endpoints.SENSOR(id));
  }


  public getUsers(): Observable<UserDTO[]> {
    return this.http.get<UserDTO[]>(Endpoints.USERS);
  }

  public createUser(data: UserDTO): Observable<any> {
    return this.http.post(Endpoints.USERS, data);
  }

  public updateUser(id:number, data: UserDTO): Observable<any> {
    return this.http.patch(Endpoints.USER(id), data);
  }

  public deleteUser (id: number): Observable<any> {
    return this.http.delete(Endpoints.USER(id));
  }

  public updateOwnOrganisationsAndSites() {
    this.commonService.getOwnOrganisationsAndSites().subscribe((data: OwnOrganisationsAndSites[]) =>
      localStorage.setItem(OWN_ORGANISATIONS_AND_SITES, JSON.stringify(data)));
  }
}
